export class Space {
    id = ""
    name = ""
    private = false
    color = null
    avatar = ""
    archived=false
    constructor(values={}) {
        Object.assign(this, values)
    }
}